import {module} from "../app";

module.directive("networkStatusChecker", function ($rootScope) {
  return {
    restrict: "E",
    replace: true,
    templateUrl: "views/templates/networkStatusChecker.html",
    link: function (scope, element) {

    }
  };
});



// WEBPACK FOOTER //
// ./src/scripts/directives/networkStatusChecker.js